import type { Installment } from '@/models/catalog/offer';

export const calculateInstallmentValue = (
  price: number,
  installment: Installment
): number => {
  if (installment.fee === 0) {
    return price / installment.max;
  }
  return (price / installment.max) * ((100 + installment.fee) / 100);
};
